import { ICoreContext } from '@msdyn365-commerce/core';
import { SimpleProduct } from '@msdyn365-commerce/retail-proxy';

const translations: { [key: string]: { [key: string]: string } } = {
    'nb-NO': {
        stk: 'Enh',
        'Flaske-BS': 'Stk',
        'Flaske-M1': 'Krt',
        'Stk-BS': 'Stk',
        'Stk-M1': 'Krt',
        'Stk-M2': 'Krt',
        'Stk-TP': 'Pall',
        'Boks-BS': 'Stk',
        'Boks-M1': 'Krt',
        'Krt-BS': 'Stk',
        'Krt-M1': 'Krt',
        'Krt-M2': 'Krt',
        'Krt-TP': 'Pall',
        'Pose-BS': 'Stk',
        'Pose-M1': 'Krt',
        'Pose-TP': 'Pall',
        'Kanne-BS': 'Stk',
        'Kanne-M1': 'Krt',
        'Fat-BS': 'Stk',
        'Fat-M1': 'Krt',
        'Glass-BS': 'Stk',
        'Rull-BS': 'Stk',
        'Rull-M1': 'Krt',
        'Brett-BS': 'Stk',
        'Brett-M1': 'Brt',
        'Brett-M2': 'Brt',
        'Tube-BS': 'Stk',
        'Sekk-BS': 'Stk',
        'Sekk-M1': 'Krt',
        'Bunt-BS': 'Stk',
        'Bunt-M1': 'Krt',
        'Pall-TP': 'Pall',

        '100_meter': '',
        Behandling: ''
    },
    'en-US': {
        stk: 'Unit',
        'Flaske-BS': 'Pcs',
        'Flaske-M1': 'Box',
        'Stk-BS': 'Pcs',
        'Stk-M1': 'Box',
        'Stk-M2': 'Box',
        'Stk-TP': 'Pallet',
        'Boks-BS': 'Pcs',
        'Boks-M1': 'Box',
        'Krt-BS': 'Pcs',
        'Krt-M1': 'Box',
        'Krt-M2': 'Box',
        'Krt-TP': 'Pallet',
        'Pose-BS': 'Pcs',
        'Pose-M1': 'Box',
        'Pose-TP': 'Pallet',
        'Kanne-BS': 'Pcs',
        'Kanne-M1': 'Box',
        'Fat-BS': 'Pcs',
        'Fat-M1': 'Box',
        'Glass-BS': 'Pcs',
        'Rull-BS': 'Pcs',
        'Rull-M1': 'Box',
        'Brett-BS': 'Pcs',
        'Brett-M1': 'Try',
        'Brett-M2': 'Try',
        'Tube-BS': 'Pcs',
        'Sekk-BS': 'Pcs',
        'Sekk-M1': 'Box',
        'Bunt-BS': 'Pcs',
        'Bunt-M1': 'Box',
        'Pall-TP': 'Pallet',

        '100_meter': '',
        Behandling: ''
    }
};

export function humanizeUnitOfMeasure(
    locale: ICoreContext | string,
    unitOfMeasure: string | undefined,
    simpleProduct?: SimpleProduct
): string {
    if (!unitOfMeasure) {
        return '';
    }

    // Check if locale is a string or an ICoreContext object
    if (typeof locale === 'object') {
        locale = locale.request.locale;
    }

    return translations[locale]?.[unitOfMeasure] || unitOfMeasure;
}
